import { useLanguage } from './LanguageContext';
import type { Lang } from './types';

type LanguageSwitcherProps = {
  hidden?: boolean;
};

export default function LanguageSwitcher({ hidden = false }: LanguageSwitcherProps) {
  const { lang, setLang } = useLanguage();

  const toggle = (next: Lang) => {
    if (next !== lang) setLang(next);
  };

  return (
    <div
      className={`lang-switcher${hidden ? ' lang-switcher--hidden' : ''}`}
      role="group"
      aria-label="Language"
      aria-hidden={hidden}
    >
      <button
        type="button"
        className={`lang-switcher__btn ${lang === 'vi' ? 'lang-switcher__btn--active' : ''}`}
        onClick={() => toggle('vi')}
        aria-pressed={lang === 'vi'}
      >
        VI
      </button>
      <button
        type="button"
        className={`lang-switcher__btn ${lang === 'en' ? 'lang-switcher__btn--active' : ''}`}
        onClick={() => toggle('en')}
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
    </div>
  );
}